<template>
	<div class="reviewTaskManage mw1340">
		<el-header class="breadCrumbs">
			<el-breadcrumb separator="/">
				<i class="iconfont icon-home fl mr10"></i>
				<el-breadcrumb-item>智能审查</el-breadcrumb-item>
				<el-breadcrumb-item>审查统计分析</el-breadcrumb-item>
			</el-breadcrumb>
		</el-header>
		<el-container>
			<el-main class="reviewAnalyze-wrap">
				<div class="reviewAnalyzeMain-t">
					<el-row type="flex" class="row-bg" justify="space-around">
						<el-col :span="7">
							<div class="grid-content bg-purple shadowlaw mb6">
								<div class="chartBox">
									<div class="chartsBox">
										<chartsBar

											:chartsBarData="chartsBarData"
											ref="chartsBar"
											v-loading="loadingChartsBar"
										></chartsBar>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="10">
							<div class="grid-content bg-purple-light shadowlaw">
								<div class="chartBox">
									<div class="chartsBox chartsBoxPieRing por">
										<chartsPieRing
											:chartsPieRingData="
												chartsPieRingData
											"
											ref="chartsPieRing"
											v-loading="loadingChartsPieRing"
										></chartsPieRing>
										<div class="poa allNum">
											<p>
												审查任务总数：
												<span>{{ totalSum.item_sum }}</span> 个
											</p>
											<p>
												审查报告总数：
												<span>{{ totalSum.report_sum }}</span> 篇
											</p>
											<p>
												审查意见总数：
												<span>{{ totalSum.advice_sum }}</span> 条
											</p>
										</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="7">
							<div class="grid-content bg-purple shadowlaw">
								<div class="chartBox">
									<div class="chartsBox chartsBoxPie">
										<chartsPieLine
											:chartsPieLineData="
												chartsPieLineData
											"
											ref="chartsPieLine"
											v-loading="loadingChartsPieLine"
										></chartsPieLine>
									</div>
									<div class="chartsBoxLine"></div>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="reviewAnalyzeMain-b">
					<el-row type="flex" class="row-bg" justify="space-around">
						<el-col :span="12">
							<reviewAnalyzeTable
								data="originalText"
							></reviewAnalyzeTable>
						</el-col>
						<el-col :span="12">
							<reviewAnalyzeTable
								data="report"
							></reviewAnalyzeTable>
						</el-col>
					</el-row>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
// //引入Echarts主模块
// var echarts = require("echarts/lib/echarts");
// //引入柱状图
// require("echarts/lib/chart/bar");
// //引入折线图
// require("echarts/lib/chart/line");

// //引入提示框、标题组件、工具栏、缩放组件、图例组件
// require("echarts/lib/component/tooltip");
// require("echarts/lib/component/title");
// require("echarts/lib/component/toolbox");
// require("echarts/lib/component/dataZoom");
// require("echarts/lib/component/legend");

//柱状图
import chartsBar from "./chartsBar.vue";
//环形图
import chartsPieRing from "./chartsPieRing.vue";
//饼图+折线图
import chartsPieLine from "./chartsPieLine.vue";
//下方表格
import reviewAnalyzeTable from "./reviewAnalyzeTable.vue";
export default {
	components: {
		chartsBar,
		chartsPieRing,
		chartsPieLine,
		reviewAnalyzeTable,
	},
	data() {
		return {
			//柱状图
			chartsBarData: {
				id: "chartsBar",
				height: "400px", //calc( 68vh)
				xData:[],
        title: "审查任务总体情况",
				// xData: [
				// 	"审查报告数",
				// 	"审查原文总数",
				// 	"审查总任务数",
				// 	"已完成任务数",
				// ],
				yData: [],
				// yData: [30, 40, 50, 60],
				yData2: [],
				// yData2: [60, 50, 40, 90],
				bottom: "6%",
				end: 100, //缩放组件默认显示
				path: "/parResult/",
				idNum: [], //科研人员ID
				name: "审查任务总体情况", //图片下载名称
				// legend: ["整篇审查", "条目审查"],
				legend: [],
			},
			loadingChartsBar: false, //加载中

			//环形图
			chartsPieRingData: {
				id: "chartsPieRing",
				height: "400px", //calc( 68vh)
				bottom: "6%",
				path: "/parResult/",
				name: "审查意见分布情况", //图片下载名称
				data: [], //数据
				// data:[
				// 	{
				// 		name: "建议修改",
				// 		value: 1,
				// 	},
				// 	{
				// 		name: "建议删除",
				// 		value: 2,
				// 	},
				// 	{
				// 		name: "建议增加",
				// 		value: 3,
				//    }
				// ],
				colorData: ["#25C5E8", "#FBC57A", "#AF48EE"],
			},
			loadingChartsPieRing: false, //加载中
			totalSum: {}, //总数

			//饼线图
			chartsPieLineData: {
				id: "chartsPieLine",
				height: "400px",
				bottom: "6%",
				colorData: ["#A9C2FB", "#7FC8FF"],
				name: "近期审查任务情况",
				source:[]
			},
			loadingChartsPieLine: false, //加载中
		};
	},
	created() {
		this.getTotalSumFun(); //获取总数
		this.getTotalTaskFun(); //审查任务总体情况
		this.getTotalOpinionFun();//审查意见分布情况
		this.getTotalReviewTaskFun();//近期审查任务情况
	},
	methods: {
		//获取总数
		getTotalSumFun() {
			this.loadingChartsBar=true;
			this.axios.get("/japi/check/statistics/?tag=total").then((res) => {
				if (res.data.code == 200) {
					console.log("获取总数======");
					console.log(res);
					this.loadingChartsBar=false;
					this.totalSum = res.data.data.total;
				} else if (res.data.code == 500) {
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000,
					});
				} else {
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000,
					});
				}
			});
		},

		//审查任务总体情况-柱状图
		getTotalTaskFun() {
			this.axios
				.get("/japi/check/statistics/?tag=item_type_total")
				.then((res) => {
					if (res.data.code == 200) {
						console.log("审查任务总体情况-柱状图======");
						console.log(res);
						this.chartsBarData.xData=res.data.data.item_type_total.order_label;
						res.data.data.item_type_total.check_types.forEach((item)=>{
							this.chartsBarData.legend.push(item.brief);
						});
						this.chartsBarData.yData=res.data.data.item_type_total.file;
						this.chartsBarData.yData2=res.data.data.item_type_total.item;
						this.$refs.chartsBar.drawCharts(); //调子组件的方法
					} else if (res.data.code == 500) {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					} else {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					}
				});
		},

		//审查意见分布情况-环形图
		getTotalOpinionFun() {
			this.loadingChartsPieRing=true;
			this.axios
				.get("/japi/check/statistics/?tag=advice_group")
				.then((res) => {
					if (res.data.code == 200) {
						console.log("审查意见分布情况-环形图======");
						console.log(res);
						this.loadingChartsPieRing=false;

						this.chartsPieRingData.data=res.data.data.advice_group;
						this.chartsPieRingData.data=JSON.parse(JSON.stringify(this.chartsPieRingData.data).replace(/advise_type/g, 'name').replace(/item_sum/g, 'value'));
						this.$refs.chartsPieRing.drawCharts(); //调子组件的方法
						// console.log(this.$refs.chartsPieRing);
					} else if (res.data.code == 500) {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					} else {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					}
				});
		},

		//近期审查任务情况-饼图+折线图
		getTotalReviewTaskFun() {
			this.loadingChartsPieLine=true;
			this.axios
				.get("/japi/check/statistics/?tag=item_month_group")
				.then((res) => {
					if (res.data.code == 200) {
						console.log("近期审查任务情况-饼图+折线图======");
						console.log(res);
						this.loadingChartsPieLine=false;
						this.chartsPieLineData.source=res.data.data.item_month_group;
						this.$refs.chartsPieLine.drawCharts(); //调子组件的方法
					} else if (res.data.code == 500) {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					} else {
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000,
						});
					}
				});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/mixin.scss"; //定义方法
@import "../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>